import { CREATE_USER_SUCCESS } from '../../actions/create-user';
import { UPDATE_USER_SUCCESS } from '../../actions/update-user';
import { SET_CURRENT_USER } from '../../actions/set-current-user';
import { USER_SET_PERMISSIONS } from '../../actions/user-socket';
import { LOGOUT_MEMBER_SUCCESS } from '../../actions/logout-member';
import { SET_AUTH } from '../../actions/set-auth';
import { UPDATE_USER_PRIVACY_STATUS } from '../../actions/update-user-privacy-status';

export default (state = null, { type, payload = {} } = {}) => {
  switch (type) {
    case SET_CURRENT_USER:
    case CREATE_USER_SUCCESS:
      return { ...(state || {}), ...payload };
    case UPDATE_USER_SUCCESS:
    case USER_SET_PERMISSIONS:
      return state && state._id === payload._id ? {
        ...state,
        ...payload,
      } : state;
    case LOGOUT_MEMBER_SUCCESS:
      return null;
    case SET_AUTH:
      return {
        ...state,
        ...payload.currentUser,
      };
    case UPDATE_USER_PRIVACY_STATUS:
      return {
        ...state,
        privacyStatus: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/auth/current-user.js